import { render } from "./SchemasSelect.vue?vue&type=template&id=a80158c0&scoped=true"
import script from "./SchemasSelect.vue?vue&type=script&lang=js"
export * from "./SchemasSelect.vue?vue&type=script&lang=js"

import "./SchemasSelect.vue?vue&type=style&index=0&id=a80158c0&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80158c0"]])

export default __exports__